import { Link } from 'react-router';

import { Button } from '@mds/shared/ui/shadcn/button';

export default function NotFoundPage() {
  return (
    <div className="mx-auto flex max-w-page flex-col items-start px-gutter py-section">
      <p className="font-mono text-sm text-muted-foreground">404</p>
      <h1 className="mt-2 text-3xl font-semibold tracking-tight">Page not found</h1>
      <p className="mt-2 text-muted-foreground">That route does not exist yet.</p>
      <Button className="mt-6" asChild>
        <Link to="/">Back home</Link>
      </Button>
    </div>
  );
}
